import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Leaves } from 'shared/lib/types';

import { GroupDto } from 'entities/group';

type ObjectLeaves = Leaves<GroupDto>;

export type TableColumns = Extract<ObjectLeaves, 'id' | 'name' | 'comment'>;

export type TableColumnsState = Record<TableColumns, boolean>;

const initialState: TableColumnsState = {
  id: true,
  name: true,
  comment: true,
};

const slice = createSlice({
  name: 'groupsTable',
  initialState,
  reducers: {
    setVisibleColumns: (state, action: PayloadAction<TableColumnsState>) => {
      return action.payload;
    },
  },
});

export const { setVisibleColumns } = slice.actions;
export default slice.reducer;
